<script setup lang="ts">
import { ISeparatedItem } from '@caks/shared/modules/i'
import { OrderItem } from '.'
import { CartItem } from '../../../../shared/types/types.user'
import { useAccountStore } from '@caks/shared/store/store.account'
import { getWordEnding } from '@caks/shared/utils/formatHelpers'

const props = defineProps<{
  cartItems: CartItem[]
  discount: number
  isDeliveryAmount: number
  errorText: string
  productError: boolean
}>()
const store = useAccountStore()

const totalPrice = computed(() => {
  return props.cartItems.reduce((acc, el) => {
    return (acc += el.cost * el.amount)
  }, 0)
})

const amount = props.cartItems.reduce((acc, el) => {
  return (acc += el.amount)
}, 0)

const deliveryInfoVisible = computed(() => {
  return (
    localStorage.getItem('order') === 'delivery' && store.promo?.activation_rule === 'free_delivery'
  )
})
</script>

<template>
  <div class="order-list">
    <h3 class="order-list__title">Состав заказа</h3>
    <div class="order-list__list">
      <div v-for="item in cartItems">
        <order-item :product="item" :cost="item.cost" />
        <i-separated-item class="product__sepaartor" />
      </div>
    </div>
    <div v-if="productError" class="product__error">
      <p>{{ errorText }}</p>
    </div>
    <div class="product__total total">
      <div class="total__info">
        <p>{{ amount }} товар{{ getWordEnding(amount) }} на сумму</p>
        <p>{{ totalPrice }}₽</p>
      </div>
      <div v-if="discount" class="total__info total__info_discount">
        <p>Скидка</p>
        <p>-{{ discount }}₽</p>
      </div>
      <div v-if="deliveryInfoVisible" class="total__info">
        <p>Доставка</p>
        <p>Бесплатно</p>
      </div>
      <div class="total__info" v-if="isDeliveryAmount > 0">
        <h4>Доставка:</h4>
        <h4>{{ isDeliveryAmount }}</h4>
      </div>
      <i-separated-item class="product__sepaartor" />
      <div class="total__price">
        <h3>Стоимость заказа</h3>
        <h3>{{ totalPrice - discount + isDeliveryAmount }}₽</h3>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.order-list {
  display: flex;
  flex-direction: column;
  padding: 32px;
  border-radius: 16px;
  box-shadow: 0 0 5px #0000000d;
  min-width: 460px;

  &__title {
    @include h3-5;
    margin-bottom: 48px;
  }

  &__list {
    overflow-y: auto;
    max-height: 264px;
    margin-bottom: 24px;

    &::-webkit-scrollbar {
      width: 10px;
    }

    &::-webkit-scrollbar-track {
      background: $ui-gray-2;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: $sub-text;
      border-radius: 10px;
      border: 2px solid $ui-gray-2;
    }
  }

  .total {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;

    &__info {
      display: flex;
      justify-content: space-between;
      @include h5-2;
      color: $primary-text;

      &_discount {
        color: $primary-green;
      }
    }

    &__price {
      display: flex;
      justify-content: space-between;
      @include h3-5;
    }
  }
}

.product__sepaartor {
  margin: 24px 0 0;
}

.product__error {
  @include h5-2;
  color: $primary-red;
  margin-bottom: 20px;
}
</style>
